var ACCEPTABLE_TIME_EXCESS_RATE = 0.3;
var MIN_EXCESS_TIME = 3;
export var isTimeExceeded = function (averageTime, spentTime) {
    return spentTime > MIN_EXCESS_TIME &&
        spentTime > averageTime + averageTime * ACCEPTABLE_TIME_EXCESS_RATE;
};
